import './NotFoundWidget.scss';

interface NotFoundWidgetProps {
  label?: string;
  reloadLabel?: string;
  onReload?: () => void;
}

const NotFoundWidget = ({ label = 'No users found', reloadLabel = 'Reload', onReload }: NotFoundWidgetProps) => {

  return (
    <div className="cop-not-found-widget">
      <svg className="cop-not-found-widget__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" fill="none">
        <circle cx="52" cy="52" r="28" stroke="#000" strokeWidth="4"/>
        <circle cx="52" cy="52" r="20" stroke="#000" strokeWidth="3"/>
        <circle cx="43" cy="36" r="2" fill="#000"/>
        <circle cx="51" cy="34" r="2" fill="#000"/>
        <path d="M45 45L59 59M59 45L45 59" stroke="#000" strokeWidth="4" strokeLinecap="round"/>
        <rect x="73" y="71" width="12" height="40" rx="6" transform="rotate(-45 73 71)" stroke="#000" strokeWidth="4" fill="#fff"/>
      </svg>
      <p className="cop-not-found-widget__label">{label}</p>
      <button
        type="button"
        className="cop-not-found-widget__reload-btn"
        onClick={onReload}
      >
        {reloadLabel}
      </button>
    </div>
  );
};

export default NotFoundWidget;